import { useCallback } from 'react'
import { requests } from '../../../core/ajax'

export const useEEPPCalls = () => {
  const { get } = requests

  const getEEPP = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        get('/empresa_ca/tabla_empresas_prescriptoras', config)
          .then((response) => {
            return resolve(response)
          })
          .catch(({ response }) => {
            return reject(response)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return {
    getEEPP,
  }
}
